import React from "react";
import { Stack } from "@mantine/core";

import Tag from "../../../spaces_neo/presentations/discussion/Tag";

export default function InteractiveTags(props) {
  return (
    <Stack mt={20}>
      <Tag
        section="settings"
        global={true}
        type={"message"}
        spaceId={props.element.node.attrs.id}
        tags={Array.isArray(props.tags) ? props.tags : []}
        onUpdatedMessage={() => {}}
      />
    </Stack>
  );
}
